import { ErrorResponse } from 'api/types'
import { request } from 'api/utils'
import { addQueryString, Filter } from 'utils/addQueryString'
import { PATH } from './constants'
import { BookingHistoryFilters, GetBookingHistoryListResponse } from './types'

class Api {
  public baseUrl: string = process.env.REACT_APP_API_URL || ''

  async getBookingHistoryList(
    pageSize: number,
    pageIndex: number,
    companyId = '',
    filters?: Filter[],
    sorting?: string
  ) {
    return request<GetBookingHistoryListResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(
        PATH.BOOKING_HISTORY_LIST,
        {
          companyId,
          pageSize,
          pageIndex,
        },
        filters,
        sorting
      )
    )
  }

  getBookingHistoryFiltersData(companyId = '', fromDate = '', toDate = '') {
    return request<BookingHistoryFilters, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.BOOKING_HISTORY_FILTERS_DATA, {
        companyId,
        fromDate,
        toDate,
      })
    )
  }

  exportBookingHistory(
    companyId: number,
    pageSize = '',
    pageIndex = '',
    filters?: Filter[]
  ) {
    return request<string, ErrorResponse>(
      this.baseUrl,
      addQueryString(
        PATH.BOOKING_HISTORY_EXPORT,
        {
          companyId,
          pageIndex,
          pageSize,
        },
        filters
      ),
      { method: 'GET' },
      undefined,
      'blob'
    )
  }
}

export const bookingHistoryApi = new Api()
